import { InsuranceType } from "@bluefalcon/clients-management-client-fetch";

export const insuranceTypes: Record<InsuranceType, string> = {
    'medicare': 'Medicare',
    'medicaid': 'Medicaid',
    'individual': 'Individual',
    'employer': 'Employer',
    'other': 'Other',
};
